// Default WordPress JS

// SVG
import './svg/jquery.svg';
console.log( 'SVG JS Loaded' );

// Slick
import './slick/slick';
console.log( 'Slick Loaded' );

// Vendors
import './inc/vendor/jquery-closestchild';

// Custom
import './inc/setup';
import './inc/burger';
import './inc/slider';
import './inc/accordion';
import './inc/scroll-animation';
import './inc/parallax';
import './inc/form';

console.log( 'Main JS Loaded' );



// WEBPACK FOOTER //
// ./src/js/main.js